import { memo } from 'react';
import ModelResponseRankingTaskComponent from './ModelResponseRankingTaskComponent';
import { StepViewComponentProps } from '../../stepDescriptor/types';

const ModelResponseRankingViewComponent = (props: StepViewComponentProps) => {
  return <ModelResponseRankingTaskComponent {...props} isPinnable isPinnedView={false} />;
};

export default memo(ModelResponseRankingViewComponent);
